import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
    IOption,
} from '../../../../../base';
import { FilterContainer } from './CheckboxFilter.styles';
import { Control, Controller, FieldValues } from 'react-hook-form';

export interface Props {
    title: string;
    options: Array<IOption>;
    control: Control<FieldValues>;
    name: string;
}

const CheckboxFilter = ({ title, options, control, name }: Props) => {
    const sanitizeFieldName = (value: string | null) => {
        if (!value) return '';
        return encodeURIComponent(value);
    };

    return (
        <FilterContainer>
            <Typography variant="subtitle1" gutterBottom>
                {title}
            </Typography>
            <FormGroup>
                {options.map((option) => (
                    <Controller
                        key={sanitizeFieldName(option.value)}
                        name={`${name}.${sanitizeFieldName(option.value)}`}
                        control={control}
                        render={({
                            field: { onChange, value, ref, ...field },
                        }) => (
                            <FormControlLabel
                                sx={{
                                    marginInlineStart: '-11px',
                                }}
                                control={
                                    <Checkbox
                                        {...field}
                                        inputRef={ref}
                                        checked={value}
                                        onChange={(e) =>
                                            onChange(e.target.checked)
                                        }
                                    />
                                }
                                label={option.label}
                            />
                        )}
                    />
                ))}
            </FormGroup>
        </FilterContainer>
    );
};

export default CheckboxFilter;
